import { PREFIX } from "../../constant/base";

export const TooltipHandlerType = {
    dom: `${PREFIX}_TOOLTIP_HANDLER_DOM`,
    canvas: `${PREFIX}_TOOLTIP_HANDLER_CANVAS`
};

export const TOOLTIP_EL_CLASS_NAME = "vchart-tooltip-element";

export const TOOLTIP_MAX_LINE_COUNT = 20;

export const TOOLTIP_OTHERS_LINE = {
    key: "其他",
    value: "..."
};

export var TooltipType;

!function(TooltipType) {
    TooltipType.group = "group", TooltipType.mark = "mark", TooltipType.dimension = "dimension";
}(TooltipType || (TooltipType = {}));

export const DEFAULT_SHOW_DELAY = 50;
//# sourceMappingURL=constant.js.map
